import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { start } from "repl";

const FAQData = [
  {
    questNo: 1,
    quest: "How does Kwik Engage improve customer engagement?",
    response:
      "Kwik Engage enables two-way personalized campaigns, automates customer journeys, and provides deep insights for data-driven marketing.",
  },
  {
    questNo: 2,
    quest: "Can Kwik Engage integrate with my Shopify store?",
    response:
      "Yes! Kwik Engage seamlessly integrates with Shopify, custom stores, and mobile apps.",
  },
  {
    questNo: 3,
    quest: "What channels does Kwik Engage support?",
    response:
      "It works across WhatsApp, Email, SMS, Instagram, Facebook, and on-site pop-ups.",
  },
  {
    questNo: 4,
    quest: "How does Kwik Engage help recover abandoned carts?",
    response:
      "It uses smart segmentation and automated messaging to retarget users via WhatsApp, SMS, and Email.",
  },
  {
    questNo: 5,
    quest: "Is customer data secure with Kwik Engage?",
    response:
      "Absolutely. We follow industry-best security standards to protect customer data.",
  },
  {
    questNo: 6,
    quest: "Can I A/B test my campaigns?",
    response:
      "Yes! Kwik Engage allows A/B testing to optimize campaign effectiveness and improve conversion rates.",
  },
  {
    questNo: 7,
    quest: "What are the pricing plans for Kwik Engage?",
    response:
      "Pricing varies based on features and usage. Contact our sales team for a custom quote.",
  },
];

export const SectionSeven = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <div className="container-fluid" style={{ marginTop: "80px" }}>
        <div
          style={{ textAlign: "center", color: "black", marginBottom: "40px" }}
        >
          <h1
            style={{
              fontSize: "28px",
              marginBottom: "10px",
              fontWeight: "700",
            }}
          >
            FAQs
          </h1>
        </div>

        <div className="mt-3 mb-5">
          <div
            className="faq-section"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start", // changed from 'center'
              gap: "20px",
              maxWidth: "1200px",
              margin: "0 auto",
            }}
          >
            {FAQData.map((faq, index) => (
              <div
                key={faq.questNo}
                style={{
                  backgroundColor: "#F7A125",
                  color: "black",
                  padding: "0 15px",
                  borderRadius: "10px",
                  width: "45%",
                  minWidth: "300px",
                  cursor: "pointer",
                  boxSizing: "border-box",
                  minHeight: activeIndex === index ? "auto" : "50px",
                  height: activeIndex === index ? "auto" : "50px",
                  overflow: "hidden",
                  transition: "height 0.3s ease",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    minHeight: "50px",
                  }}
                  onClick={() => toggleAccordion(index)}
                >
                  {activeIndex === index ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                  <h4
                    style={{
                      fontSize: "16.5px",
                      fontWeight: 500,
                      margin: 0,
                      paddingRight: "20px",
                      paddingLeft: "20px",
                      textAlign: "start",
                    }}
                  >
                    {faq.quest}
                  </h4>
                </div>

                <div
                  style={{
                    marginLeft: "35px",
                    opacity: activeIndex === index ? 1 : 0,
                    height: activeIndex === index ? "auto" : 0,
                    overflow: "hidden",
                    transition: "opacity 0.5s ease",
                  }}
                >
                  {Array.isArray(faq.response) ? (
                    faq.response.map((section, idx) => (
                      <div key={idx} style={{ marginBottom: "15px" }}>
                        <h5
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginBottom: "8px",
                          }}
                        >
                          {section.title}
                        </h5>
                        <ul
                          style={{
                            margin: 0,
                            paddingLeft: "20px",
                          }}
                        >
                          {section.content.map((item, i) => (
                            <li
                              key={i}
                              style={{
                                marginBottom: "5px",
                                lineHeight: "1.4",
                              }}
                            >
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))
                  ) : (
                    <p
                      style={{
                        margin: 0,
                        lineHeight: "1.5",
                      }}
                    >
                      {faq.response}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div>
        <div style={{ textAlign: "center", color: "black", marginTop: "40px" }}>
          <h1
            style={{
              fontSize: "28px",
              marginBottom: "30px",
              fontWeight: "700",
              marginTop: "100px",
            }}
          >
            Resources
          </h1>
          <div className="resources-sec" style={{ overflowX: "scroll" }}>
            <a
              href="https://www.gokwik.co/success-story/amydus-uplifts-customer-retention-using-kwikengage"
              target="_blank"
            >
              <div className="resources-card" style={{ cursor: "pointer" }}>
                <img src="/assets/images/kwikengage/resgroup1.png" alt="" />
                <p>Amydus Uplifts Customer Retention by 85% Using KwikEngage</p>
                <p className="know-more ">Know More {">"}</p>
              </div>
            </a>

            <a
              href="https://www.gokwik.co/success-story/fireboltt-sets-endtoend-whatsapp-retention-marketing-with-kwikengage"
              target="_blank"
            >
              <div className="resources-card" style={{ cursor: "pointer" }}>
                <img src="/assets/images/kwikengage/resgroup2.png" alt="" />
                <p style={{ fontSize: "15.1px" }}>
                  Fire-Boltt Sets End-to-end WhatsApp Retention Marketing With
                  KwikEngage
                </p>
                <p className="know-more">Know More {">"}</p>
              </div>
            </a>

            <a
              href="https://www.gokwik.co/success-story/true-elements-increases-abandoned-cart-recovery-by-134-with-kwikengage"
              target="_blank"
            >
              <div className="resources-card" style={{ cursor: "pointer" }}>
                <img src="/assets/images/kwikengage/resgroup3.png" alt="" />
                <p>True Elements Increases Abandoned Cart Recovery by 134%</p>
                <p className="know-more">Know More {">"}</p>
              </div>
            </a>

            <a
              href="https://www.gokwik.co/blog/crafting-hypertargeted-marketing-campaigns-with-list-and-segment-integration"
              target="_blank"
            >
              <div className="resources-card" style={{ cursor: "pointer" }}>
                <img src="/assets/images/kwikengage/resgroup4.png" alt="" />
                <p>True Elements Increases Abandoned Cart Recovery by 134%</p>
                <p className="know-more">Know More {">"}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
